module.exports = __webpack_public_path__ + "img/complete.26843fa6.svg";